import ModalHtml from '../html/modal-html';
import jQuery3 from '../jQuery/jQuery';

const config = {
    selectors: {
        module: '.rfct-modal',
        closeButton: '.rfct-modal__close-button',
        rfct: '.rfct',
        buttons: '.rfct-modal__button-container .rfct-button',
        content: '.rfct-modal__content',
    },
    classNames: {
        visible: 'rfct-modal--visible',
        noScroll: 'no-scroll',
    },
};

const modals = new Map();

export default class Modal {
    /**
     * Modal constructor
     * @param {string | function} content String to use as modal content.
     * If this is a function the function is called with the content element
     * so a custom logic can be applied to insert the content into the modal.
     * @param {string} id Optional ID to identify the modal
     * @param {object} conf Config object
     */
    constructor(content, id, conf) {
        if (id && modals.has(id)) {
            return modals.get(id);
        }

        this._content = content;
        this._id = id;
        this._config = conf;
        this._$rootElement = this._createRootElement();
        this._elements = this._getDomElements();
        this._appended = false;

        if (this._id) {
            modals.set(this._id, this);
        }

        this._init();
    }

    _createRootElement() {
        const html = (new ModalHtml('', this._config)).toString();
        return jQuery3(html);
    }

    _getDomElements() {
        return {
            $body: jQuery3(document.body),
            $rfct: jQuery3(config.selectors.rfct).first(),
            $closeButton: this._$rootElement.find(config.selectors.closeButton),
            $content: this._$rootElement.find(config.selectors.content),
        };
    }

    _init() {
        this._addEventListeners();
        this._fillContent();
    }

    _addEventListeners() {
        this._elements.$closeButton.on('click', () => {
            this.hide();
        });

        if (this._config && this._config.buttons && this._config.buttons.length) {
            const $renderedButtons = this._$rootElement.find(config.selectors.buttons);

            this._config.buttons.forEach((button, index) => {
                if (typeof button.onClick !== 'function') {
                    return;
                }

                const $renderedButton = jQuery3($renderedButtons[index]);

                $renderedButton.on('click', (e) => {
                    button.onClick(e);
                });
            });
        }
    }

    _fillContent() {
        switch (typeof this._content) {
            case 'string':
                this._elements.$content.html(this._content);
                break;
            case 'function':
                this._content(this._elements.$content);
                break;
            default:
                this._elements.$content.html('');
                break;
        }
    }

    show() {
        if (!this._appended) {
            this._elements.$rfct.append(this._$rootElement);
            this._appended = true;
        }

        setTimeout(() => {
            this._$rootElement.addClass(config.classNames.visible);
            this._elements.$body.addClass(config.classNames.noScroll);
        }, 0);
    }

    hide() {
        this._$rootElement.removeClass(config.classNames.visible);
        this._elements.$body.removeClass(config.classNames.noScroll);
    }

    setContent(content) {
        this._content = content;
        this._fillContent();
    }
}
